import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

export const useGetAllDataSourcesService = () => {
  const allDataSourcesService = useQuery({
    queryKey: [...CACHE_KEYS.DATA_SOURCES],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS.DATA_SOURCES,
      });
    },
  });
  return { services: { allDataSourcesService } };
};
